module.exports = __webpack_public_path__ + "static/media/clinical-appointment-bg.1a442712.png";